import PropTypes from "prop-types";

export const PanelAppType = PropTypes.shape({
  items: PropTypes.arrayOf(
    PropTypes.shape({
      evidences: PropTypes.arrayOf(PropTypes.string),
      genecolorreview: PropTypes.string,
      genelistdescription: PropTypes.string,
      genelistname: PropTypes.string,
      genelistotherdata: PropTypes.shape({
        currentversion: PropTypes.string,
        relevant_disorders: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            id: PropTypes.number,
          })
        ),
        types: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            id: PropTypes.number,
          })
        ),
      }),
      levelofconfidence: PropTypes.string,
      modeofinheritance: PropTypes.string,
      modeofpathogenicity: PropTypes.string,
      panelid: PropTypes.string,
      penetrance: PropTypes.string,
      phenotypes: PropTypes.arrayOf(PropTypes.string),
      pub_med_references: PropTypes.arrayOf(PropTypes.number),
    })
  ),
  version: PropTypes.string,
});
